/* eslint-disable */

document.addEventListener('on:variant:change', function (evt) {
  var section = evt.target.closest('.js-product');
  if (!section) return;

  var variant = evt.detail && evt.detail.variant;
  var variantId = variant ? String(variant.id) : null;

  var blockIds = new Set();
  section.querySelectorAll('[data-spec-block]').forEach(function (el) {
    blockIds.add(el.getAttribute('data-spec-block'));
  });

  blockIds.forEach(function (blockId) {
    section.querySelectorAll('[data-spec-block="' + blockId + '"]').forEach(function (el) {
      el.setAttribute('hidden', '');
    });

    var matchEl = variantId
      ? section.querySelector('[data-spec-block="' + blockId + '"][data-variant-spec="' + variantId + '"]')
      : null;

    if (matchEl) matchEl.removeAttribute('hidden');
  });
});
